
import { Component, Vue, Prop, Mixins } from "vue-property-decorator";
import { namespace, Mutation, Action, Getter } from "vuex-class";
import { DispatchRequest, MobileFeatures, DispatchType } from "@/store/mobile/types";
import { GuardTour, GuardTourStep } from "@/store/guard-tours/types";
import { UserPermissions } from "@/store/types";
import api from "@/services/api.mobile.service";
import DispatchMixin from "@/mixins/DispatchMixin";

const Mobile = namespace("mobile");
const GuardTours = namespace("GuardTours");

@Component
export default class DispatchQueueItem extends Mixins(DispatchMixin) {
    @Getter("getPermissions") public permissions: UserPermissions;

	// Feature flag
	@Mobile.Getter("getMobileFeatures") getMobileFeatures: MobileFeatures;

    @Mobile.Mutation setFocalPoint: any;
    @Mobile.Action guardArrived: ({dispatchQueueId: number, hasArrived: boolean}) => Promise<void>;

	@Mobile.Action public claimDispatchRequest: (dispatchQueueId: number) => Promise<void>;
    @Mobile.Action public unclaimDispatchRequest: (dispatchQueueId: number) => Promise<void>;
    @Mobile.Action public activateDispatchRequest: (dispatchQueueId: number) => Promise<void>;
    @Mobile.Action public inactivateDispatchRequest: (dispatchQueueId: number) => Promise<void>;

    @Mobile.Action public promoteSelfToIncidentCommander: (dispatchQueueId: number) => Promise<void>;

    @GuardTours.Action fetchGuardTour;
	@GuardTours.Getter getGuardTour: (guardTourId: number) => GuardTour;

	@Prop()
	public dispatchRequest: DispatchRequest; 

	private expanded: boolean = false;
	private tour: GuardTour = null;

	private async mounted() {
		this.tour = this.getGuardTour(this.dispatchRequest.guardTourId);
		if (!this.tour && this.dispatchRequest.guardTourId) {
            await this.fetchGuardTour(this.dispatchRequest.guardTourId);
            this.tour = this.getGuardTour(this.dispatchRequest.guardTourId);
		}
	}

	public showOnMap(location: string) {
		const position = this.parseLocationToLatLng(location);
		this.setFocalPoint(position);
	}

	public claimUnclaimDispatchRequest(dispatchRequest: DispatchRequest) {
		if (dispatchRequest.claimed) {
			this.unclaimDispatchRequest(dispatchRequest.dispatchQueueID);
		} else {
			this.claimDispatchRequest(dispatchRequest.dispatchQueueID);
		}
	}

	public activateInactivateHandler(dispatchRequest: DispatchRequest) {
		this.$emit("cancelled-arrived");
		this.guardArrived({dispatchQueueId: dispatchRequest.dispatchQueueID, hasArrived: false});

		if (dispatchRequest.active) {
			this.inactivateDispatchRequest(dispatchRequest.dispatchQueueID);
		} else {
			this.activateDispatchRequest(dispatchRequest.dispatchQueueID);
			this.showOnMap(dispatchRequest.location);
		}
	}

    public get incidentCommanderTitle() {
        const { isIncidentCommander, incidentCommanderCallsign } = this.dispatchRequest;

        if (isIncidentCommander) {
            return "You";
        } else if (!incidentCommanderCallsign) {
            return "Unassigned";
        } else {
            return incidentCommanderCallsign;
        }
    }

    public async promoteSelfToCommander() {
        if (!this.permissions.canPromoteSelfToIC) {
            return;
        }

        const { dispatchQueueID } = this.dispatchRequest;

        // Ensure the user has this request active if they're becoming the incident commander
        if (!this.dispatchRequest.active) {
            await this.activateDispatchRequest(dispatchQueueID);
        }

        // Promote to incident commander
        await this.promoteSelfToIncidentCommander(dispatchQueueID);
    }
}
